var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-version-table'),_c('loading',{attrs:{"state":_vm.$store.getters.initiallyLoading(['formVersions'])}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }